(function() {
    'use strict';
    
a3_pilot_reports.controller('AcknowledgeModalCtrl', AcknowledgeModalCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name AcknowledgeModalCtrl
    * @description 
    * Warning Modal about unread mandatory memos
    * @ngInject
    */
    function AcknowledgeModalCtrl($scope, ScheduleAcknowledgeFactory, $route, $uibModalInstance) {

        $scope.ConfirmAcknowledge = ConfirmAcknowledge;
        $scope.cancel = cancel;
        $scope.showContent = 'confirm';
        $scope.responseObj = { success: false, message: '', Results: [] };
        $scope.results = [];

        function ConfirmAcknowledge(){
            $scope.showContent = 'loading';
            ScheduleAcknowledgeFactory.acknowledgeChanges()
                .then(res => handleSubmitResponse(res))
                .catch(res => handleSubmitResponse(res));
 
        }

        function handleSubmitResponse(res) {
            $scope.showContent = 'results';
            $scope.responseObj = res;

            if(res.Results && res.Results.some(s=> !s.IsSuccess)){
                $scope.responseObj.success = false;
                $scope.responseObj.message = 'Some dates cannot be acknowledged';
            }
            
        }

        /**
        * Closes modal
        * @memberof ProposalInfoModalCtr
        */
        function cancel() {
            $uibModalInstance.close('cancel');

            if($scope.responseObj.success){
                $route.reload();
            }
        }
    }

})();
